// src/superAdminService.js
import axios from 'axios';
import Cookies from 'js-cookie';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${Cookies.get('superAdminToken')}`
  }
});

export const superAdminService = {
  // Get dashboard stats
  getStats: async () => {
    try {
      const response = await axios.get(
        `${API_URL}/apis/superAdmin/stats`,
        getHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Stats API Error:', error);
      return { success: false, data: { stats: { pending: 0, approved: 0, rejected: 0 } } };
    }
  },

  // Get pending approvals
  getPendingApprovals: async () => {
    try {
      const response = await axios.get(
        `${API_URL}/apis/superAdmin/pending`,
        getHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Pending API Error:', error);
      return { success: false, data: [] };
    }
  },

  // Get all colleges
  getColleges: async () => {
    try {
      const response = await axios.get(
        `${API_URL}/apis/superAdmin/colleges`,
        getHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Get colleges error:', error);
      return { success: false, data: [], error: error.message };
    }
  },

  // Get all admins
  getAdmins: async () => {
    try {
      const response = await axios.get(
        `${API_URL}/apis/superAdmin/admins`,
        getHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Get admins error:', error);
      return { success: false, data: [], error: error.message };
    }
  },

  // In superAdminService.js
approveCollege: async (collegeId) => {
  // Ensure collegeId is a string and clean it
  const cleanId = String(collegeId).trim();
  
  console.log('Approving college with ID:', cleanId);
  
  if (!cleanId || cleanId === 'undefined' || cleanId === 'null') {
    return { success: false, error: 'Invalid college ID' };
  }
  
  try {
    const response = await axios.put(
      `${API_URL}/apis/superAdmin/approve/${cleanId}`,
      {},
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Approve college error:', error.response?.data || error.message);
    return { 
      success: false, 
      error: error.response?.data?.message || 'Failed to approve college' 
    };
  }
},

  // Reject college
  rejectCollege: async (collegeId, rejectionReason, adminNotes = '') => {
    try {
      const response = await axios.put(
        `${API_URL}/apis/superAdmin/reject/${collegeId}`,
        { rejectionReason, adminNotes },
        getHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Reject college error:', error);
      return { success: false, error: error.message };
    }
  },
// In superAdminService.js - COMPLETE FIX
suspendCollege: async (collegeId, reason) => {
  console.log('🔍 SUSPEND SERVICE CALLED WITH:', { collegeId, reason, type: typeof collegeId });
  
  // Validate ID exists
  if (!collegeId) {
    console.error('❌ No college ID provided');
    return { success: false, error: 'No college ID provided' };
  }

  // Convert to string and trim
  const idString = String(collegeId).trim();
  console.log('Processed ID string:', idString);

  // REMOVE the ObjectId format validation temporarily
  // Just check if it's not empty
  if (!idString || idString === 'undefined' || idString === 'null') {
    console.error('❌ Invalid ID after processing:', idString);
    return { success: false, error: 'Invalid college ID' };
  }

  try {
    console.log('Making API request to:', `${API_URL}/apis/superAdmin/suspend/${idString}`);
    
    const response = await axios.put(
      `${API_URL}/apis/superAdmin/suspend/${idString}`,
      { reason },
      getHeaders()
    );
    
    console.log('✅ API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ API error:', {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    
    // Return the actual error from server if available
    if (error.response?.data) {
      return { 
        success: false, 
        error: error.response.data.message || 'Server error',
        details: error.response.data
      };
    }
    
    return { success: false, error: error.message || 'Failed to suspend college' };
  }
},

  // Unsuspend college
  unsuspendCollege: async (collegeId) => {
    try {
      const response = await axios.put(
        `${API_URL}/apis/superAdmin/unsuspend/${collegeId}`,
        {},
        getHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Unsuspend college error:', error);
      return { success: false, error: error.message };
    }
  },

  // Delete college
  deleteCollege: async (collegeId) => {
    try {
      const response = await axios.delete(
        `${API_URL}/apis/superAdmin/colleges/${collegeId}`,
        getHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Delete college error:', error);
      return { success: false, error: error.message };
    }
  },

  // Logout
  logout: () => {
    Cookies.remove('superAdminToken');
    localStorage.removeItem('superAdminEmail');
    window.location.href = '/login';
  }
};